import { render } from "./MainCard.vue?vue&type=template&id=1df6c650"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"
script.render = render

export default script